import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategoryNav from './components/CategoryNav';
import LatestUpdate from './components/LatestUpdate';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/comics';

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '汗汗漫画',
  url: 'https://hanhancomic.com',
  description: siteInfo.description,
  email: siteInfo.email,
  telephone: siteInfo.phone,
  address: {
    '@type': 'PostalAddress',
    streetAddress: '望京SOHO T1 1206室',
    addressLocality: '北京',
    addressRegion: '朝阳区',
    addressCountry: 'CN',
  },
};

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '汗汗漫画',
  url: 'https://hanhancomic.com',
  description: siteInfo.description,
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://hanhancomic.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const webpageJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '汗汗漫画 - 免费韩国漫画在线阅读',
  description: siteInfo.description,
  url: 'https://hanhancomic.com',
  isPartOf: {
    '@type': 'WebSite',
    name: '汗汗漫画',
    url: 'https://hanhancomic.com',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageJsonLd) }}
      />

      <main>
        <HeroSection />
        <HotRecommend />
        <CategoryNav />
        <LatestUpdate />
        <FAQSection />
      </main>
    </>
  );
}